import app from "firebase";

export const fsFieldvalue = app.firestore.FieldValue;

export const fsTimestamp = app.firestore.Timestamp;
